export default __webpack_public_path__ + "static/media/gt4.46e48e7d.png";